export default __webpack_public_path__ + "static/img-kortical-timeline-2b03f48dbfb1e1dd4ed591825c7342f2.webp";